import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('ancillary_rate_factor_set', '/ancillary_rate_factor_sets')
const actions = generator.generate()

export default actions
